import { createContext, useContext } from 'react';
import { Optional } from '@/generic/functional';
import type { Page } from '@/generic/pagination';
import type { RulesFileToImport } from '@/rules-management/domain/RulesFileToImport.ts';
import type { DraftRule } from '@/rules-management/domain/DraftRule.ts';
import type { ExtractionFailure } from '@/rules-management/primary/ExtractionFailure.ts';

export type RuleExtractionTrackingToast = { kind: 'success' } | { kind: 'failure' };

export type RuleExtractionTracking = {
  visible: boolean;
  extracting: boolean;
  failure: Optional<ExtractionFailure>;
  drafts: Optional<Page<DraftRule>>;
  toast: Optional<RuleExtractionTrackingToast>;
  openImport: () => void;
  closeImport: () => void;
  extract: (file: RulesFileToImport) => Promise<void>;
  retry: () => void;
  continueInBackground: () => void;
  dismissFailure: () => void;
  dismissToast: () => void;
  notifyPageMounted: (mounted: boolean) => void;
};

export const RuleExtractionTrackingReactContext = createContext<Optional<RuleExtractionTracking>>(
  Optional.empty(),
);

export const useRuleExtractionTracking = (): RuleExtractionTracking =>
  useContext(RuleExtractionTrackingReactContext).orElseThrow(
    () =>
      new Error('useRuleExtractionTracking must be used within a RuleExtractionTrackingProvider'),
  );
